var _rect, _path, _path2, _path3, _path4, _path5, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazilRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#009C34"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.10001L13.5 7.50001L7.5 11.9L1.5 7.50001",
    fill: "#F8E23D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49995 10.3C9.04635 10.3 10.3 9.04644 10.3 7.50004C10.3 5.95365 9.04635 4.70004 7.49995 4.70004C5.95355 4.70004 4.69995 5.95365 4.69995 7.50004C4.69995 9.04644 5.95355 10.3 7.49995 10.3Z",
    fill: "#002478"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30005 8.70004V9.50004H7.10005V8.70004H6.30005ZM7.90005 8.70004V9.50004H8.70005V8.70004H7.90005Z",
    fill: "#C9D0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6.30002C5.5 6.30002 7.3112 6.62002 8.6168 7.17842L10.3 7.90002",
    fill: "#C9D0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.30002C5.5 6.30002 7.3112 6.62002 8.6168 7.17842L10.3 7.90002",
    stroke: "#C9D0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "black",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilRound);
export default __webpack_public_path__ + "static/media/brazil-round.16fd2a400a23c90582486ddba9c5fcf9.svg";
export { ForwardRef as ReactComponent };